import '../styles/Education.css';
import { TargetEducation } from './ui/TargetEducation.jsx';

export function Education(){
  return(
    <section id="education" className="education">
      <h3 className="title">Credenciales profesionales</h3>

      <div className="education-content">

        <h4 className="education-group">Estudios</h4>
        <div className="education-grid">
          <TargetEducation
            period="2025 – 2026"
            title="Maestría en Ciencias, mención Informática"
            org="Escuela de Posgrado, UNSAAC, Cusco"
            note="Egresado"
          />
          <TargetEducation
            period="2024"
            title="Ingeniero Informático y de Sistemas"
            org="Universidad Nacional de San Antonio Abad del Cusco"
            note="Quinto superior"
          />
          <TargetEducation
            period="2021"
            title="Bachiller en Ingeniería Informática y de Sistemas"
            org="Universidad Nacional de San Antonio Abad del Cusco"
            note="Quinto superior"
          />
        </div>

        <h4 className="education-group">Especialización y certificaciones clave</h4>
        <div className="education-grid">
          <TargetEducation
            period="Set. 2025 – Feb. 2026"
            title="Diplomado en Transformación Digital en el Sector Público"
            org="Universidad Nacional San Luis Gonzaga, Ica"
          />
          <TargetEducation
            period="Oct. 2025"
            title="Pasantía en sistemas de información web, móviles, sedes electrónicas públicas y administración electrónica"
            org="Diputación de Córdoba, España"
          />
          <TargetEducation
            period="Mar. 2026"
            title="Diplomado en Gobierno de TI y Gestión de Servicios: ITIL + COBIT"
            org="Elévate Perú"
          />
          <TargetEducation
            period="2026"
            title="Ciberseguridad: Ethical Hacking (C|EH) + IA"
            org="Universidad Nacional de Ingeniería (UNI)"
          />
          <TargetEducation
            period="2024"
            title="Seguridad de la Información ISO 27001"
            org="Seguridad Cero"
          />
          <TargetEducation
            period="2024"
            title="SCRUM Foundation Professional Certification (SFPC)"
            org="CertiProf"
          />
        </div>

        <p className="text education-languages">
          <b>Idiomas:</b> español (lengua materna), inglés avanzado (Instituto de Idiomas UNSAAC) y portugués (autodidacta).
        </p>

      </div>
    </section>
  );
}
